import SideNavigation, { type SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { useT } from '@vextura/i18n';
import { useLocation, useNavigate } from 'react-router-dom';
import { toCloudscapeItems } from './nav.config.js';

type FollowEvent = Parameters<NonNullable<SideNavigationProps['onFollow']>>[0];

export function SideNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const t = useT('shell');
  // Feed the translator into toCloudscapeItems so every group + item +
  // sub-item label goes through i18next. When the user picks a new
  // language, i18next fires languageChanged, useT re-renders, and the
  // sidebar labels update in place — no page refresh needed.
  const translate = (key: string, fallback: string): string => {
    const translated = t(key);
    // useT returns the key itself on miss — use the caller's fallback in
    // that case so we never render "shell:nav.items.iam".
    return translated === key ? fallback : translated;
  };
  return (
    <SideNavigation
      header={{ text: t('nav.header'), href: '/' }}
      // Match the deepest registered nav link, so e.g. /iam/users highlights
      // the Users sub-item rather than the IAM parent.
      activeHref={pathname}
      items={toCloudscapeItems(pathname, translate)}
      onFollow={(e: FollowEvent) => {
        if (!e.detail.external) {
          e.preventDefault();
          navigate(e.detail.href);
        }
      }}
    />
  );
}
